import React from "react";
import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";

export default function KpiTile({ label, value, sublabel, trend, accent = "default", icon: Icon, testId }) {
  const accents = {
    default: "border-zinc-200",
    critical: "border-l-[3px] border-l-[#DC2626] border-zinc-200",
    warning: "border-l-[3px] border-l-[#F59E0B] border-zinc-200",
    primary: "border-l-[3px] border-l-[#002FA7] border-zinc-200",
    success: "border-l-[3px] border-l-[#16A34A] border-zinc-200",
  };
  const TrendIcon = trend > 0 ? ArrowUpRight : trend < 0 ? ArrowDownRight : Minus;
  const trendColor = trend > 0 ? "text-[#16A34A]" : trend < 0 ? "text-[#DC2626]" : "text-zinc-400";
  return (
    <div
      data-testid={testId}
      className={`bg-white border ${accents[accent]} p-5 transition-colors hover:bg-zinc-50/40`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="data-label">{label}</div>
        {Icon && <Icon className="w-4 h-4 text-zinc-400" />}
      </div>
      <div className="metric text-[28px] leading-none tracking-tight font-medium text-zinc-900">{value}</div>
      {(sublabel || trend !== undefined) && (
        <div className="mt-3 flex items-center gap-2 text-xs">
          {trend !== undefined && (
            <span className={`inline-flex items-center gap-0.5 ${trendColor} metric`}>
              <TrendIcon className="w-3 h-3" />
              {Math.abs(trend)}%
            </span>
          )}
          {sublabel && <span className="text-zinc-500">{sublabel}</span>}
        </div>
      )}
    </div>
  );
}
